import React, { useMemo } from 'react'

import { UseFormWatch } from 'react-hook-form'
import { UseFormSetValue } from 'react-hook-form/dist/types/form'

import { Tooltip, Txt } from 'src/components/atoms'
import { SelectInternalUsersInput, TableSortType } from 'src/components/molecules'
import { InternalAssignUserEditTableHead } from 'src/components/molecules/projects/InternalAssignUserEditTableHead'
import { InternalAssignUserSortItemType } from 'src/components/molecules/projects/InternalAssignUserTableHead'

import { useGetUsers } from 'src/hooks'
import {
  InternalUserEntity,
  ProfileEntity,
  ProjectAssignUser,
  UpsertProjectFormEntity,
} from 'src/types'

type Props = {
  profile?: ProfileEntity
  watch: UseFormWatch<UpsertProjectFormEntity>
  setValue: UseFormSetValue<UpsertProjectFormEntity>
  sortItem: InternalAssignUserSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: InternalAssignUserSortItemType) => void
  onSelectSortType: (newType: TableSortType) => void
  className?: string
}

export function InternalAssignUserEditTableTop({
  profile,
  watch,
  setValue,
  sortItem,
  sortType,
  onSelectItem,
  onSelectSortType,
  className,
}: Props) {
  const { loading, users: internalUsers } = useGetUsers()

  const excludedInternalUsers = useMemo(() => {
    if (loading) {
      return
    }
    return internalUsers.filter(user =>
      watch('projectUsers').some(assignedUser => assignedUser.id === user.id)
    )
  }, [internalUsers, loading, watch])

  const handleOnSelectInternalUser = (user: InternalUserEntity) => {
    const assignedUser: ProjectAssignUser = { id: user.id, email: user.email, name: user.name }
    setValue('projectUsers', [...watch('projectUsers'), assignedUser])
  }

  const handleOnBatchSelect = (users: InternalUserEntity[]) => {
    const assignedUsers: ProjectAssignUser[] = users.map(user => ({
      id: user.id,
      email: user.email,
      name: user.name,
    }))
    setValue('projectUsers', [...watch('projectUsers'), ...assignedUsers])
  }

  return (
    <div className={className}>
      <div className="tw-bg-surface-secondary tw-px-s0 tw-py-s-2 tw-rounded-t-[8px] tw-overflow-hidden">
        <Tooltip
          content={
            <Txt sizeType="s">
              「ユーザー」画面で追加済のユーザー名で検索して「決
              <br />
              定」で指定メールアドレスへ、このROOV compassプロ
              <br />
              ジェクトへアサインを知らせるメールが送信されます。
            </Txt>
          }
        >
          <Txt sizeType="s" className="tw-font-bold">
            社内ユーザー
          </Txt>
        </Tooltip>
      </div>
      <SelectInternalUsersInput
        excludedInternalUsers={excludedInternalUsers}
        profile={profile}
        onSelectInternalUser={handleOnSelectInternalUser}
        onBatchSelect={handleOnBatchSelect}
      />
      <InternalAssignUserEditTableHead
        sortItem={sortItem}
        sortType={sortType}
        onSelectItem={onSelectItem}
        onSelectSortType={onSelectSortType}
        className="tw-border-b tw-border-b-border-secondary"
      />
    </div>
  )
}
